import { render, staticRenderFns } from "./RaiseDetailPanel.vue?vue&type=template&id=50630cc7&scoped=true"
import script from "./RaiseDetailPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RaiseDetailPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RaiseDetailPanel.vue?vue&type=style&index=0&id=50630cc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50630cc7",
  null
  
)

export default component.exports